import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: () => import('./views/ShipmentSearch'),
    },
    {
      path: '/:shipment',
      component: () => import('./views/ShipmentDetail'),
    },
    {
      path: '/:shipment/review',
      component: () => import('./views/ShipmentReview'),
    },
    {
      path: '/:shipment/reviewed',
      component: () => import('./views/ShipmentReviewed'),
    },
    {
      path: '/error',
      component: () => import('./views/ShipmentNotFound'),
    },
  ],
})
